import { styled } from "baseui";

export const Video = styled("video", ({ $theme }) => ({
  display: "block",
  maxWidth: "min(900px, 100%)",
  maxHeight: "600px",
  marginTop: $theme.sizing.scale700,
  marginBottom: $theme.sizing.scale700,
  marginLeft: "auto",
  marginRight: "auto",
  gridColumn: 1,
  boxSizing: "border-box",
  boxShadow: "0px 2px 0px #000000",
  border: "1.5px solid black",
  borderRadius: $theme.borders.radius200,
}));
